<template>
    <div>
      <c-search-box @enter="getList">
        <template slot="search">
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <!-- 사업장 -->
            <c-plant type="search" name="plantCd" v-model="searchParam.plantCd"  @datachange="datachange"/>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <!-- 측정년도 -->
            <c-datepicker
              name="measYear"
              type="year"
              :range="true"
              label="측정년도"
              v-model="year"
              @datachange="datachange"
            ></c-datepicker>
          </div>
          <!-- <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-select
              codeGroupCd="WORK_MEAS_QUARTER_CD"
              type="search"
              itemText="codeName"
              itemValue="code"
              name="measQuarter"
              label="분기"
              v-model="searchParam.measQuarter"
              @datachange="datachange"
            ></c-select>
          </div> -->
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-text
              :editable="editable"
              :disabled="true"
              :afterIcon="[
                { name: 'search', click: true, callbackName: 'searchHazard' },
                { name: 'close', click: true, callbackName: 'removeHazard' }
              ]"
              label="유해인자"
              name="hazardNames"
              v-model="searchParam.hazardNames"
              @searchHazard="openHazard"
              @removeHazard="removeHazard">
            </c-text>
          </div>
        </template>
      </c-search-box>
      <div class="col-12" style="background:#fff;">
        <apexchart 
          ref="chart" 
          height="680" 
          type="line"
          :width="chart.chartWidth"
          :options="chart.chartOptions" 
          :series="chart.series"></apexchart>
      </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import selectConfig from '@/js/selectConfig';
import VueApexCharts from "vue-apexcharts";
export default {
  name: 'work-measure-result-graph',
  components: {
    apexchart: VueApexCharts
  },
  props: {
  },
  data() {
    return {
      fullscreen: false,
      searchParam: {
        plantCd: '',
        measQuarter: null,
        measYear: '',
        startYmd: '',
        endYmd: '',
        hazardNames: '',
        measCompleteFlag: null,
        hazardCds: '',
      },
      year: ['', ''],
      chart: {
        chartOptions: {
          title: {
            text: '작업환경측정치 통계',
            floating: true,
            offsetY: 330,
            align: 'center',
            style: {
              color: '#444'
            }
          },
          annotations: { 
            xaxis: [],
          },
         // 그래프 설정
          chart: {
            type: 'line',
            // stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },
          xaxis: {
            categories: [], // 교육과정
          },
          yaxis: {
            title: {
              text: ''
            }
          },
          fill: {
            opacity: 1,
            colors: ['#1E90FF', '#F44336']
          },
          colors: ['#1E90FF', '#F44336'],
          tooltip: {
            y: {
              formatter: function (val) {
                return val
              }
            }
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 10
          },
        },
        series: [
          {
            name: "공정/부서/단위장소별 측정치",
            type: 'column',
            data: []
          },
          {
            name: "기준치(노출기준)",
            type: 'line',
            data: []
          },
        ],
        chartWidth: '80%',
      },
      editable: true,
      searchUrl: '',
      popupOptions: {
        isFull: false,
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
      listUrl: '',
    };
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.listUrl = selectConfig.sai.workmeas.result.chart.url;
      // 년도 설정
      let years = [];
      for (let i = 0; i < 2; i++) {
        years.splice(0, 0, this.$comm.getPrevYear(i));
      }
      this.year = [ years[0], years[1]];

      this.getList();
    },
    getList() {
      if (!this.year) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message:
          '측정년도를 선택하세요',
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      if (!this.searchParam.hazardNames) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message:
          '유해인자를 선택하세요',
          type: 'warning', // success / info / warning / error
        });
        return;
      }
      if (this.year && this.year.length > 0) {
        this.searchParam.startYmd = this.year[0];
        this.searchParam.endYmd = this.year[1];
      } 
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.chart.series[0].data = [];
        let rate = [];
        let taskIdx = -1;
        this.$_.forEach(_result.data, _item => {
          rate[++taskIdx] = _item.measValue
        })
        let xaxis = this.$_.map(_result.data, 'concatName')
        this.chart.series[0].data = this.$_.map(_result.data, 'measValue')
        this.chart.series[1].data = this.$_.map(_result.data, 'exposureStandard')
        let annotations = [];
        // rate.forEach((r, idx) => {
        //   // xaxis[idx] += (r ? '(' + r + ')' : '');
        //   annotations[idx] = {
        //     x: xaxis[idx],
        //     strokeDashArray: 0, 
        //     borderColor: '#EEEEEE',
        //     borderWidth: 0,
        //     label: {
        //       borderColor: '#775DD0',
        //       orientation: 'horizontal',
        //       style: {
        //         color: '#fff',
        //         fontSize: '12px',
        //         background: '#775DD0',
        //       },
        //       text: r ? r : '',
        //       // text: r ? '이행률 : ' + r : '',
        //     }
        //   }
        // })
        // xaxis.forEach((x, idx) => {
        //   if (!annotations[idx]) {
        //     annotations[idx] = {
        //       x: x,
        //       strokeDashArray: 0,
        //       borderColor: '#EEEEEE',
        //       borderWidth: 0,
        //       // borderColor: '#775DD0',
        //       label: {
        //         borderColor: '#775DD0',
        //         orientation: 'horizontal',
        //         style: {
        //           color: '#fff',
        //           fontSize: '12px',
        //           background: '#775DD0',
        //         },
        //         text: '',
        //       }
        //     }
        //   }
        // })
        this.chart.chartOptions.xaxis.categories = xaxis;
        this.chart.chartOptions.annotations.xaxis = annotations;
        this.chart.chartWidth = '100%';
        this.$refs['chart'].refresh();
      },);
    },
    datachange() {
      this.getList();
    },
    openHazard() {
      this.popupOptions.title = '유해인자 검색'; // 유해인자 검색
      this.popupOptions.param = {
        type: 'single',
        workEnvFlag: 'Y',
      };
      this.popupOptions.target = () => import(`${'./harmfulFactorsPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeHazardPopup;
    },
    closeHazardPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      let sum = 0;
      if (data && data.length > 0) {
        this.$_.forEach(data, _item => {
          sum++;
          if (sum === 1) {
            this.searchParam.hazardCds =  _item.hazardCd
            this.searchParam.hazardNames =  _item.hazardName
          }
        })
        this.getList();
      }
    },
    removeHazard() {
      this.searchParam.hazardCds = ''
      this.searchParam.hazardNames = '';
      this.getList();
    },
  }
};
</script>